import React from "react";
import styled from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";
import { FilterStatus } from "typings/globalGQLTypes";

const sharedStyle = `
  align-items: center;
  border-radius: 0.286rem;
  box-sizing: border-box;
  display: flex;
  font-size: 0.857rem;
  font-weight: 500;
  height: 1.714rem;
  padding: 0.286rem 0.857rem;
`;

const CompleteWrapper = styled.div`
  ${sharedStyle};
  background: #073937;
  color: #fff;
`;

const IncompleteWrapper = styled.div`
  ${sharedStyle};
  border: 1px solid ${colors.gray6};
  color: ${colors.gray6};
`;

interface CompletionStatusProps {
  className?: string;
  status: FilterStatus | null;
}

export const CompletionStatus = ({
  status,
  className,
}: CompletionStatusProps) => {
  if (status === FilterStatus.complete)
    return <CompleteWrapper className={className}>Complete</CompleteWrapper>;

  return (
    <IncompleteWrapper className={className}>Incomplete</IncompleteWrapper>
  );
};
